import { useContext } from 'react';

import { FeatureFlagContext } from '../context/featureFlag.context';

export const useFeatureFlag = () => {
  const { featureFlags } = useContext(FeatureFlagContext);

  const hasFeatureFlag = (featureFlag: string) => {
    return featureFlags.includes(featureFlag);
  };

  return {
    hasFeatureFlag,
  };
};
